import React, { ReactNode } from "react";

import { bem } from "@react-md/utils";
import Col, { ColProps } from "antd/es/col";
import Row, { RowProps } from "antd/es/row";
import cn from "classnames";

import TestProps from "../../type/TestProps";

const block = bem("mmc-label");

export interface LabeledProps extends TestProps {
  children: ReactNode;
  className?: string;
  colProps?: ColProps;
  extra?: ReactNode;
  label?: ReactNode;
  labelClassName?: string;
  labelPosition?: "side" | "top";
  required?: boolean;
  rowProps?: RowProps;
  sideLabelSpan?: number;
}

const Labeled = ({
  children,
  className,
  colProps,
  extra,
  label,
  labelClassName,
  labelPosition = "top",
  required,
  rowProps,
  sideLabelSpan = 6,
}: LabeledProps) => {
  if (labelPosition === "top") {
    return (
      <Col className={cn(block({ [labelPosition]: true }), className)} {...colProps}>
        <Row className={cn(block("label", { required }), labelClassName)} justify="space-between">
          <div>{label}</div>
          {extra && <span>{extra}</span>}
        </Row>
        <Row>{children}</Row>
      </Col>
    );
  }

  return (
    <Row className={cn(block({ [labelPosition]: true }), className)} {...rowProps}>
      <Col className={cn(block("label", { required }), labelClassName)} span={sideLabelSpan}>
        <div>{label}</div>
        {extra && <span>{extra}</span>}
      </Col>
      <Col span={24 - sideLabelSpan}>{children}</Col>
    </Row>
  );
};

export default Labeled;
